// extracted by mini-css-extract-plugin
export var deepLinkCtn = "deeplink-container-module--deepLinkCtn--7Fker";
export var linkIcon = "deeplink-container-module--linkIcon--JvE3p";